import React from 'react'
import Tabela from '../Tabela/Tabela'
import NavBar from '../Nav/NavBar'

const Main = () => {
    return (
        <>
            <NavBar/>
            <Tabela/>
        </>
    )
}

export default Main;